import { ca } from '@cian/analytics';

export type TPromotionType = 'sale' | 'mortgage' | 'bonus';

export function trackPromotionIconClick(
  promotionType: TPromotionType,
  promotionPosition: number,
  offerId: number,
  kpId: number | null,
) {
  const product = {
    id: kpId,
    offerType: 'KP',
    position: 1,
    extra: { offer_id: offerId },
  };

  ca('eventSite', {
    action: 'click_promo_icon',
    label: `${promotionPosition}/${promotionType}`,
    category: 'Card',
    name: 'oldevent',
    products: kpId ? [product] : [],
  });
}
